import { tv, type VariantProps } from "../../../util/tv";

export const logoCarouselSwiperVariant = tv({
  slots: {
    image: ["object-center object-contain mx-auto h-full opacity-30"],
    wrapper: ["h-full", "relative"],
    swiper: ["h-full"],
    slide: ["!h-auto"],
    nav: [
      "h-full w-full",
      "flex justify-between items-center",
      "absolute top-0 left-0",
      "pointer-events-none",
      "z-10",
    ],
  },
});

export type LogoCarouselSwiperVariantProps = VariantProps<
  typeof logoCarouselSwiperVariant
>;

export type LogoCarouselReturnVariantProps = ReturnType<
  typeof logoCarouselSwiperVariant
>;
